/**
 * Role-based permission definitions for SAUBHAGYA platform
 * Separated from AuthContext to enable Fast Refresh (HMR) compatibility
 */

export type UserRole = 'admin' | 'farmer' | 'manufacturing_operator' | 'sales_team' | 'transport'

export interface Permission {
  module: string
  actions: string[]
}

export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  admin: [
    { module: 'users', actions: ['create', 'read', 'update', 'delete'] },
    { module: 'devices', actions: ['manage', 'configure'] },
    { module: 'permissions', actions: ['assign', 'revoke'] },
    { module: 'audit', actions: ['view', 'export'] },
    { module: 'alerts', actions: ['configure', 'manage'] }
  ],
  farmer: [
    { module: 'biogas', actions: ['log', 'track'] },
    { module: 'contribution', actions: ['submit', 'view'] },
    { module: 'dashboard', actions: ['view', 'analyze'] },
    { module: 'reporting', actions: ['view'] }
  ],
  manufacturing_operator: [
    { module: 'production_batches', actions: ['create', 'start', 'complete', 'cancel'] },
    { module: 'transactions', actions: ['view', 'approve', 'reject'] },
    { module: 'payments', actions: ['view', 'record'] },
    { module: 'dashboard', actions: ['view', 'analyze'] },
    { module: 'reporting', actions: ['view', 'export'] }
  ],
  sales_team: [
    { module: 'inventory', actions: ['manage', 'track'] },
    { module: 'invoicing', actions: ['create', 'send'] },
    { module: 'sales', actions: ['manage', 'track'] },
    { module: 'reporting', actions: ['view', 'export'] },
    { module: 'crm', actions: ['manage', 'update'] }
  ],
  transport: [
    { module: 'vehicle_management', actions: ['manage', 'track'] },
    { module: 'route_optimization', actions: ['optimize', 'plan'] },
    { module: 'delivery_tracking', actions: ['track', 'update'] },
    { module: 'schedule_management', actions: ['schedule', 'modify'] },
    { module: 'logistics', actions: ['coordinate', 'monitor'] }
  ]
}
